import axios from '@axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async index() {
      const { data } = await axios.get('/user/radio')
      return data
    },
    async delete(a, id) {
      const { data } = await axios.delete(`/user/radio/${id}`)
      return data
    },
    async get(a, { id }) {
      const { data } = await axios.get(`/user/radio/${id}`)
      return data
    },
    async generateRadioReport(a, { payload }) {
      const { data } = await axios.post('/user/projects/generateRadioReports', payload)
      return data
    },
  },
}
